import { Component, Input, OnInit } from '@angular/core';
import { ExpenseService } from '../../services/expense.service';
import { SharedHistoryDay } from '../../interfaces/expense.interface';

@Component({
    selector: 'app-unified-history-tab',
    templateUrl: './unified-history-tab.component.html',
    styleUrls: ['./unified-history-tab.component.scss']
})
export class UnifiedHistoryTabComponent implements OnInit {
    @Input() serviceId!: number;

    historyDays: SharedHistoryDay[] = [];
    isLoading = false;

    constructor(private expenseService: ExpenseService) {}

    ngOnInit(): void {
        this.loadHistory();
    }

    loadHistory(): void {
        if (!this.serviceId) return;
        this.isLoading = true;
        this.expenseService.getSharedExpenseHistory(this.serviceId).subscribe({
            next: (res) => {
                this.historyDays = res.data || [];
                this.isLoading = false;
            },
            error: () => { this.isLoading = false; }
        });
    }

    isServiceLeftEvent(eventType: string): boolean {
        return eventType === 'service_left' || eventType === 'group_dissolved';
    }

    formatAmount(amount: number | undefined): string {
        if (amount == null) return '';
        return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2 }).format(amount);
    }

    expenseTypeLabel(type: string | undefined): string {
        const map: { [key: string]: string } = {
            fuel: 'Combustible',
            toll: 'Caseta en efectivo',
            accommodation: 'Hospedaje',
            fine: 'Multa de tránsito',
            food: 'Alimentos',
            other: 'Otros gastos'
        };
        return map[type || ''] || type || '';
    }
}
